module.exports = __webpack_public_path__ + "img/pelican.d3c1bf7.png";